import * as R from 'ramda';
var typeOnlyAction = R.partial(function (type) {
  return {
    type: type
  };
});
var actionWithPayload = R.partial(function (type, payload) {
  return {
    type: type,
    payload: payload
  };
});
export default (function (prefix) {
  var CANCEL_WIZARD = "".concat(prefix, "_CANCEL_WIZARD");
  var GO_TO_NEXT_STEP = "".concat(prefix, "_GO_TO_NEXT_STEP");
  var GO_TO_PREVIOUS_STEP = "".concat(prefix, "_GO_TO_PREVIOUS_STEP");
  var GO_TO_STEP = "".concat(prefix, "_GO_TO_STEP");
  var SET_CURRENT_STEP_IS_INVALID = "".concat(prefix, "_SET_CURRENT_STEP_IS_INVALID");
  var SET_SELECTED_WIZARD_TAB = "".concat(prefix, "_SET_SELECTED_WIZARD_TAB");
  var cancelWizard = typeOnlyAction([CANCEL_WIZARD]);
  var goToNextStep = typeOnlyAction([GO_TO_NEXT_STEP]);
  var goToPreviousStep = typeOnlyAction([GO_TO_PREVIOUS_STEP]);
  var goToStep = actionWithPayload([GO_TO_STEP]);
  var setCurrentStepIsInvalid = actionWithPayload([SET_CURRENT_STEP_IS_INVALID]);
  var setSelectedTab = actionWithPayload([SET_SELECTED_WIZARD_TAB]);
  return {
    GO_TO_NEXT_STEP: GO_TO_NEXT_STEP,
    GO_TO_PREVIOUS_STEP: GO_TO_PREVIOUS_STEP,
    GO_TO_STEP: GO_TO_STEP,
    CANCEL_WIZARD: CANCEL_WIZARD,
    SET_CURRENT_STEP_IS_INVALID: SET_CURRENT_STEP_IS_INVALID,
    SET_SELECTED_WIZARD_TAB: SET_SELECTED_WIZARD_TAB,
    goToNextStep: goToNextStep,
    goToPreviousStep: goToPreviousStep,
    goToStep: goToStep,
    cancelWizard: cancelWizard,
    setCurrentStepIsInvalid: setCurrentStepIsInvalid,
    setSelectedTab: setSelectedTab
  };
});